import { css } from 'aphrodite';
import * as React from 'react';
import { useState } from 'react';
import { Button } from '../../../../../web/components/Button';
import { Input } from '../../../../../web/components-v2/Input';
import { TagIcon } from '../../../../../web/components/svgs/icons/TagIcon';
import { XIcon } from '../../../../../web/components/svgs/icons/XIcon';
import { BlueModal } from '../../../../components/BlueModal';
import { Group } from '../../../../components/leadView/components/Group';
import { useCreatePhoneCallCategoryMutation } from '../../../../../queries/PhoneCall/usePhoneCallCategoryMutations';
import { hotPink, white } from '../../../../styles/colors';
import { styleSheet } from '../styles';

interface IProps {
	onRequestClose(success: boolean): void;
}

export const CategoryNewModal: React.FC<IProps> = ({ onRequestClose }) => {
	const [categoryName, setCategoryName] = useState('');

	const createCategory = useCreatePhoneCallCategoryMutation({ onSuccess: () => onRequestClose(true) });

	const handleSave = () => {
		createCategory.mutate({ hexColor: hotPink, name: categoryName });
	};

	const onClickToClose = () => onRequestClose?.(false);

	const handleCategoryName = (event: React.ChangeEvent<HTMLInputElement>) => {
		setCategoryName(event?.target?.value);
	};

	return (
		<BlueModal isOpen={true} onRequestClose={onRequestClose} useDefaultHeader={false} className={css(styleSheet.modal)}>
			<div className={css(styleSheet.modalHeader)}>
				<TagIcon fillColor={white} />
				<button onClick={onClickToClose}>
					<XIcon color={white} width={12} height={12} />
				</button>
			</div>
			<div className={css(styleSheet.modalContent)}>
				<Group>
					<Input
						id='filter-name-input'
						placeholder='Category Name'
						onChange={handleCategoryName}
						styles={[styleSheet.categoryNameInput]}
						type='text'
						value={categoryName}
					/>
					<Button label='Save' onClick={handleSave} />
				</Group>
			</div>
		</BlueModal>
	);
};
